import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { AppContext } from '../../../../context/AppContextProvider';
import { ILprDeviceProps } from '../../../../services/Devices/LprService/types';
import zod from 'zod';
import { Grid2 } from '@mui/material';
import TelegramSelectComponent from '../../../../components/TelegramSelectComponent';
import ButtonComponent from '../../../../components/ButtonComponent';

import WhatsAppSelectComponent from '../../../../components/WhatsAppSelectComponent';
import { RecognitionCameraConfigEditionFormSchema } from '../../../../services/Devices/Recognition/Cameras/Intelbras/RecognitionCameraService/schemas';
import { useUpdateConfigRecognitionCameraAsync } from '../../../../services/Devices/Recognition/Cameras/Intelbras/RecognitionCameraService/hooks/useMutation';
import CheckboxComponent from 'components/CheckboxComponent';
import MailSelectComponent from 'components/MailSelectComponent';
import { useSmtpIntegration } from '../../../../hooks/useSmtpIntegration';

interface RecognitionCameraConfigProps {
  isOpen: boolean;
  selectedDevice?: any;
  setSelectedDevice?: Dispatch<SetStateAction<any>>;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

type RecognitionCameraConfigEditionFormInput = zod.infer<
  typeof RecognitionCameraConfigEditionFormSchema
>;

const RecognitionCameraConfig = ({
  setIsOpen,
  setSelectedDevice,
  selectedDevice,
}: RecognitionCameraConfigProps) => {
  const { control, handleSubmit, reset, setValue } =
    useForm<RecognitionCameraConfigEditionFormInput>({
      resolver: zodResolver(RecognitionCameraConfigEditionFormSchema),
      defaultValues: {
        telegramIds: [],
        whatsAppNumbers: [],
        emailAddresses: [],
        isNotifyLogEvent: false,
        smtpIntegrationId: null,
      },
    });
  const { showSnackbar } = useContext(AppContext);
  const [selectedDeviceToConfig, setSelectedDeviceToConfig] =
    useState<ILprDeviceProps>();
  const { smtpValue, onSmtpChange } = useSmtpIntegration(control, setValue);

  const { mutate: mutateUpdateConfig } =
    useUpdateConfigRecognitionCameraAsync();

  const handleClose = () => {
    setIsOpen(false);
    reset();
    if (setSelectedDevice) setSelectedDevice({});
  };

  const onSubmit = (data: RecognitionCameraConfigEditionFormInput) => {
    if (selectedDeviceToConfig) {
      mutateUpdateConfig(
        { data, id: selectedDeviceToConfig.id },
        {
          onSuccess: () => {
            showSnackbar('Configuração atualizada com sucesso.', 'success');
            if (setSelectedDevice) setSelectedDevice({});
            reset();
            setIsOpen(false);
          },
        },
      );
    }
  };

  useEffect(() => {
    if (selectedDevice) {
      reset({
        ...selectedDevice,
        smtpIntegrationId: selectedDevice?.smtpIntegrationId || null,
      });
      setSelectedDeviceToConfig(selectedDevice);
    } else reset();
  }, [selectedDevice, reset]);

  return (
    <Grid2 container columnSpacing={3}>
      <Controller
        render={({ field: { value, onChange } }) => (
          <WhatsAppSelectComponent
            onChange={onChange}
            value={value}
            gridSize={12}
          />
        )}
        control={control}
        name={'whatsAppNumbers'}
      />
      <Controller
        render={({ field: { value, onChange } }) => (
          <TelegramSelectComponent
            onChange={onChange}
            value={value}
            gridSize={12}
          />
        )}
        control={control}
        name={'telegramIds'}
      />
      <Controller
        render={({ field: { value, onChange } }) => (
          <MailSelectComponent
            onChange={onChange}
            value={value}
            smtpValue={smtpValue}
            onSmtpChange={onSmtpChange}
          />
        )}
        control={control}
        name={'emailAddresses'}
      />
      <Controller
        render={({ field: { value, onChange } }) => (
          <CheckboxComponent
            label="Eventos de Log"
            onChange={onChange}
            value={value}
          />
        )}
        name={'isNotifyLogEvent'}
        control={control}
      />
      <Grid2 size={12} sx={{ mt: 1 }}>
        <ButtonComponent fullWidth onClick={handleSubmit(onSubmit)}>
          Salvar
        </ButtonComponent>
      </Grid2>
    </Grid2>
  );
};

export default RecognitionCameraConfig;
